<template>
  <!-- 图片预览 -->
  <el-dialog
    title="预览"
    width="600px"
    :visible.sync="visible"
    :modal-append-to-body="false"
    center>
    <el-image
      v-if="isLocal"
      :src="require('@/assets/img/' + imgUrl)"
      :preview-src-list="srcList"
      @click="handleView(imgUrl)"></el-image>
    <el-image
      v-else
      :src="imgUrl"
      :preview-src-list="srcList"
      @click="handleView(imgUrl)"></el-image>
  </el-dialog>
</template>

<script>
export default {
  props: {
    /** 是否本地图片 */
    isLocal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      /** 弹窗开关 */
      visible: false,
      /** 图片地址 */
      imgUrl: "",
      /** 大图预览列表 */
      srcList: [],
    };
  },
  methods: {
    /** 大图预览 */
    handleView(url) {
      this.srcList = [];
      if (this.isLocal) {
        this.srcList.push(require("@/assets/img/" + url));
        return;
      } else {
        this.srcList.push(url);
      }
    },
    open(url) {
      this.imgUrl = url;
      console.log("this.imgUrl", this.imgUrl);
      this.visible = true;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog--center .el-dialog__body {
  text-align: center;
  vertical-align: middle;
}
::v-deep .el-image__error {
  width: 300px;
  height: 300px;
}
</style>
